import { render, staticRenderFns } from "./Reciept.vue?vue&type=template&id=9af5eb92&scoped=true&"
import script from "./Reciept.vue?vue&type=script&lang=ts&"
export * from "./Reciept.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af5eb92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9af5eb92')) {
      api.createRecord('9af5eb92', component.options)
    } else {
      api.reload('9af5eb92', component.options)
    }
    module.hot.accept("./Reciept.vue?vue&type=template&id=9af5eb92&scoped=true&", function () {
      api.rerender('9af5eb92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/pages/Reciept.vue"
export default component.exports